import { render, staticRenderFns } from "./PsReportsPanel.vue?vue&type=template&id=89bd7f7a&scoped=true&"
import script from "./PsReportsPanel.vue?vue&type=script&lang=js&"
export * from "./PsReportsPanel.vue?vue&type=script&lang=js&"
import style0 from "./PsReportsPanel.vue?vue&type=style&index=0&id=89bd7f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bd7f7a",
  null
  
)

export default component.exports